import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const Content = props => (
  <div className={`${Styles['about-text']} portlet light`}>
    <div className="portlet-title">
      <h4>{props.portfolio.status === 2 ? 'Reject Reason' : ''}</h4>
    </div>
    <div>
      {props.portfolio.status === 2 ? props.portfolio.rejectReason : ''}
    </div>
  </div>
)

Content.propTypes = {
  portfolio: PropTypes.shape({
    status: PropTypes.number.isRequired,
    rejectReason: PropTypes.string,
  }).isRequired,
}

export default Content
